export class semester {
    id:number;
    semestername :string;
    streamid:number;
    universityid :number=1;
    }